import { render, staticRenderFns } from "./veBaseStudent.vue?vue&type=template&id=31708c26&scoped=true"
import script from "./veBaseStudent.vue?vue&type=script&lang=js"
export * from "./veBaseStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31708c26",
  null
  
)

export default component.exports